import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaWhiteSpaceFacet extends XmlSchemaFacet {}
